import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './styles.module.scss';
import { Divider } from '../../../../shared/engage/components/divider/divider';
import { useBreakpoints } from '../../hooks/use-get-breakpoints';
export var Option = function (_a) {
    var _b;
    var children = _a.children, value = _a.value, onClick = _a.onClick, isLastOption = _a.isLastOption, _c = _a.withDivider, withDivider = _c === void 0 ? false : _c, _d = _a.automationId, automationId = _d === void 0 ? null : _d;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var handleClick = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick(value);
    };
    return (_jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: classNames(styles.option, (_b = {}, _b[styles.last] = isLastOption, _b)), onClick: handleClick, "data-automation-id": "option:".concat(automationId, ":").concat(value), children: children }), ((isMobileOrSmaller && !isLastOption) || withDivider) && _jsx(Divider, {})] }));
};
